import { render, staticRenderFns } from "./Rollover.vue?vue&type=template&id=fddade28&scoped=true"
import script from "./Rollover.vue?vue&type=script&lang=js"
export * from "./Rollover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddade28",
  null
  
)

export default component.exports